/**
 * Theme-aware SweetAlert2 defaults — follows data-bs-theme / CSS variables.
 */

function isDarkTheme() {
    return document.documentElement.getAttribute('data-bs-theme') === 'dark';
}

/**
 * @returns {import('sweetalert2').SweetAlertOptions}
 */
function getSwalThemeOptions() {
    const dark = isDarkTheme();

    return {
        background: 'var(--card-background)',
        color: 'var(--text-color)',
        customClass: {
            popup: 'swal2-theme-aware',
            title: 'swal2-theme-aware__title',
            htmlContainer: 'swal2-theme-aware__html',
            confirmButton: 'swal2-theme-aware__confirm',
            cancelButton: 'swal2-theme-aware__cancel',
        },
        confirmButtonColor: '#0d6efd',
        cancelButtonColor: dark ? '#495057' : '#6c757d',
    };
}

/**
 * Wrap Swal.fire so every dialog inherits theme options (caller opts win on conflict).
 *
 * @param {import('sweetalert2').default} Swal
 * @returns {import('sweetalert2').default}
 */
function installThemedSwal(Swal) {
    if (!Swal || Swal.__labnetThemePatched) {
        return Swal;
    }

    const fire = Swal.fire.bind(Swal);

    Swal.fire = (options) => {
        if (typeof options === 'string') {
            return fire(options);
        }

        const themeOpts = getSwalThemeOptions();
        const userOpts = options ?? {};

        return fire({
            ...themeOpts,
            ...userOpts,
            customClass: {
                ...(themeOpts.customClass ?? {}),
                ...(userOpts.customClass ?? {}),
            },
        });
    };

    Swal.__labnetThemePatched = true;

    return Swal;
}

module.exports = {
    getSwalThemeOptions,
    installThemedSwal,
};
